import {  PairsObservable  } from './PairsObservable';

export const pairs = PairsObservable.create;


// WEBPACK FOOTER //
// ../../src/observable/pairs.ts